<template>
  <div class="">
    <card back class="no-print">
      <template v-slot:header>
        <h3>صدور فاکــــتور</h3>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-5 col-12">
            <small id="LblTblCostomer">مربوط به مشتری</small>
            <SearchableCombo
              :key="comboKey"
              :edit="false"
              :grp="0"
              :code="null"
              @ResultCombo="GetResultTblCostomer"
              :rownumintable="3"
              :defaultvalue="DataAxios.TblCustomerId"
              :action="'TblCrmCombo/GetCostomerProduct'"
              :method="'POST'"
              :idinput="'TblCostomer'"
              :keyItem="'TblCostomer'"
              :disabled="Disable"
              :ClassProps="'required'"
            >
            </SearchableCombo>
          </div>
          <div class="col-md-3 col-12" v-if="DataAxios.TblCustomerId > 0">
            <small id="LblTblContract"> انتخاب قرارداد </small>
            <SearchableCombo
              v-if="$store.state.renderComponentCombo"
              :edit="false"
              :grp="0"
              :code="null"
              :disabled="Disable"
              @ResultCombo="GetResulContract"
              :rownumintable="3"
              :defaultvalue="refGetResulContract"
              :action="'TblCrmCombo/GetContract/' + DataAxios.TblCustomerId"
              :method="'POST'"
              :idinput="'remot'"
              class="position-relative"
              :keyItem="'remot'"
            >
            </SearchableCombo>
          </div>
          <div
            class="col-md-4 col-12"
            dir="rtl"
            v-if="DataAxios.TblContractId > 0"
          >
            <small id="LblTblCustomerProduct"> انتخاب محصولات </small>
            <treeselect
              name="CustomerContract"
              :multiple="multiple"
              :clearable="clearable"
              :searchable="searchable"
              :disabled="disabled"
              :open-on-click="openOnClick"
              :open-on-focus="openOnFocus"
              :clear-on-select="clearOnSelect"
              :close-on-select="closeOnSelect"
              :always-open="alwaysOpen"
              :append-to-body="appendToBody"
              :options="options"
              v-model="value"
              :normalizer="normalizer"
              @select="ItemSelected"
              @deselect="ItemDeselect"
            >
            </treeselect>
          </div>
          <div
            class="col-md-4 col-12"
            v-if="DataAxios.TblContractId > 0 && $route.params.Status != 'Edit'"
          >
            <small id="LblTblCostomer"> پانویس فاکتور </small>
            <SearchableCombo
              v-if="$store.state.renderComponentGrid"
              :edit="false"
              :grp="51"
              :code="null"
              @ResultCombo="GetResultPishNevis"
              :rownumintable="3"
              :defaultvalue="null"
              :action="'TblCrmCombo/GetComboById'"
              :method="'POST'"
              :idinput="'TblFactorPish'"
              :keyItem="'TblFactorPish'"
              :ClassProps="'required'"
            >
            </SearchableCombo>
          </div>
        </div>
      </template>
    </card>

    <card>
      <template v-slot:header>
        <h3>پیش نمایش فاکــــتور</h3>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row mt-2 p-3 mx-1" v-if="ErrorList.length > 0">
          <div class="col-12 text-danger">
            <span class="text-danger" style="font-size: 15px"
              >خطاهای موجود در فاکتور</span
            >
          </div>
          <div
            class="d-block text-warning col-12"
            v-for="(item, index) in ErrorList"
            :key="index"
          >
            <small>{{ index + 1 }}- {{ item.Text }}</small>
          </div>
        </div>
        <div class="row mt-2 p-3 mx-1 D_Products">
          <div class="col-12 text-center text-secondary">
            اطلاعات کالا و یا خدمات مورد معامله
          </div>
        </div>
        <div class="row mt-2 p-3 mx-1">
          <div class="col-md-3 col-12"></div>
          <div class="col-md-3 col-12 text-left pl-0">
            <i
              v-if="$route.params.Status == 'Edit'"
              class="fad fa-sync fa-2x Pointer mt-4"
              title="ایجاد شماره سریال جدید"
              @click="ReGetSerialNum"
              style="color: var(--logo-color)"
            ></i>
          </div>
          <div class="col-md-3 col-12 text-center">
            <small> شماره سریال </small
            ><input
              type="number"
              class="form-control text-center required d-inline"
              v-model="DataAxios.SerialId"
            />
          </div>
          <div class="col-md-3 col-12 text-center">
            <small> تاریخ </small>
            <span class="d-block">
              <date-picker
                color="dimgray"
                input-class="required form-control text-center"
                v-model="DataAxios.IssueDate"
                placeholder=" تاریخ "
              ></date-picker>
            </span>
          </div>
        </div>
        <table class="table table-bordered table-hover mt-2">
          <thead class="">
            <tr>
              <th style="width: 1% !important">ردیف</th>
              <th style="width: 5% !important">کد کالا</th>
              <th style="width: 30% !important">شرح کالا | خدمات</th>
              <th style="width: 5% !important">تعداد</th>
              <th style="width: 10% !important">
                مبلغ واحد <small>( ریال )</small>
              </th>
              <th>مبلغ کل <small class="d-block">( ریال )</small></th>
              <th style="width: 10% !important">مبلغ تخفیف</th>
              <th style="width: 10% !important">
                مبلغ پس از تخفیف <small class="d-block">( ریال )</small>
              </th>
              <th style="width: 10% !important" v-if="DataAxios.IsRasmi">
                جمع مالیات و عوارض <small>( ریال )</small>
              </th>
              <th v-if="DataAxios.IsRasmi">
                جمع مبلغ با احتساب مالیات و عوارض <small>( ریال )</small>
              </th>
              <th v-else>جمع مبلغ کل <small>( ریال )</small></th>
            </tr>
          </thead>
          <tbody class="" id="GFactor">
            <tr v-for="(item, index) in ListProducts" :key="index">
              <td style="width: 1% !important">
                <span>{{ index + 1 }}</span>
              </td>
              <td style="width: 5% !important">
                <span>{{ item.Id }}</span>
              </td>

              <td style="width: 30% !important; text-align: center">
                <input
                  type="text"
                  class="form-control 3ragham required"
                  v-model="item.Name"
                />
              </td>
              <td style="width: 5% !important; text-align: center">
                <input
                  type="number"
                  class="form-control text-center required px-0"
                  @input="CalcCount($event, item)"
                  v-model="item.Count"
                />
              </td>
              <td style="width: 10% !important; text-align: center">
                <input
                  type="text"
                  class="form-control 3ragham required"
                  @keyup="item.Amount = $PutCommatoInput_New($event)"
                  @input="CalcAmount($event, item)"
                  v-model="item.Amount"
                />
              </td>
              <td style="text-align: center">
                {{ $Comma3ragham(item.AmountKol) }}
              </td>
              <td style="width: 10% !important; text-align: center">
                <input
                  type="text"
                  class="form-control text-center 3ragham required"
                  @keyup="item.Discount = $PutCommatoInput_New($event)"
                  @input="CalcDiscount($event, item)"
                  v-model="item.Discount"
                />
              </td>
              <td style="width: 10% !important; text-align: center">
                {{ $Comma3ragham(item.Miniaturize_AmountDiscount) }}
              </td>
              <td
                style="width: 10% !important; text-align: center"
                v-if="DataAxios.IsRasmi"
              >
                {{ $Comma3ragham(item.SumTollTax) }}
              </td>
              <td style="text-align: center">
                <span>{{ $Comma3ragham(item.TotallAmount) }}</span>
              </td>
            </tr>
            <tr v-if="IsCalc && ListProducts.length > 0">
              <td colspan="5" style="text-align: left">جمع کـــل :</td>
              <td style="text-align: center" class="bg-secondary">
                {{ $Comma3ragham(TR_Result.S_Amount) }}
              </td>
              <td style="text-align: center" class="bg-secondary">
                {{ $Comma3ragham(TR_Result.S_Discount) }}
              </td>
              <td style="text-align: center" class="bg-secondary">
                {{ $Comma3ragham(TR_Result.S_Miniaturize_AmountDiscount) }}
              </td>
              <td
                style="text-align: center"
                class="bg-secondary"
                v-if="DataAxios.IsRasmi"
              >
                {{ $Comma3ragham(TR_Result.S_SumTollTax) }}
              </td>
              <td style="text-align: center" class="bg-secondary">
                {{ $Comma3ragham(TR_Result.S_SumTotallAmount) }}
              </td>
            </tr>
            <tr v-if="IsCalc && ListProducts.length > 0" class="mt-3">
              <td colspan="5" style="text-align: right">
                <input
                  type="text"
                  placeholder="توضیحات فاکــــتور"
                  class="form-control 3ragham"
                  v-model="DataAxios.Description"
                />
              </td>
              <td colspan="5" style="text-align: right">
                <span class="mt-2">
                  جمع کل مبلغ به حروف :
                  <b class="font-weight-bold">
                    {{ Mab2persian(TR_Result.S_SumTotallAmount) }}</b
                  ></span
                >
              </td>
            </tr>
          </tbody>
        </table>
        <div class="row">
          <div class="col-md-3 col-12">
            <button
              class="btn btn-success"
              @click="SetFactor"
              v-if="
                ErrorList.length == 0 &&
                ListProducts.length > 0 &&
                $route.params.Status != 'Edit'
              "
            >
              ثبت فاکتــــور
            </button>
            <button
              class="btn btn-warning"
              @click="EditFactor"
              v-if="
                ErrorList.length == 0 &&
                ListProducts.length > 0 &&
                $route.params.Status == 'Edit'
              "
            >
              ویرایش فاکتــــور
            </button>
          </div>
        </div>
      </template>
    </card>
  </div>
</template>
<script>
import Num2persian from "num2persian";
import Card from "../../../components/Card/Card.vue";
import SearchableCombo from "../../../components/Combo/SearchableCombo.vue";
import Treeselect from "@riophae/vue-treeselect";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  components: {
    Card,
    SearchableCombo,
    Treeselect,
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      ArzeshAfzode1402:0.09,
      ArzeshAfzode1403 :0.1,
      comboKey: 0,
      refGetResulContract: null,
      DataAxios: {
        TblCustomerId: 0,
        TblContractId: 0,
        Description: "",
        IssueDate: "",
        SerialId: "",
        IsRasmi: true,
      },
      options: [],
      multiple: true,
      clearable: false,
      searchable: true,
      disabled: false,
      openOnClick: true,
      openOnFocus: false,
      clearOnSelect: true,
      closeOnSelect: false,
      alwaysOpen: false,
      appendToBody: false,
      value: [],
      normalizer(node) {
        return {
          id: node.Id,
          label: node.Name,
        };
      },
      ListProducts: [],
      IsCalc: false,
      TR_Result: {
        S_Amount: 0,
        S_Discount: 0,
        S_Miniaturize_AmountDiscount: 0,
        S_SumTollTax: 0,
        S_SumTotallAmount: 0,
      },
      CopyCustomerProducts: [],
      Factors: [],
      ErrorList: [],
      Disable: false,
      IsTarixFactor:false
    };
  },
  props: ["propstblCustomerProducts", "propsFactor", "Status"],
  methods: {
    GetResultTblCostomer(val) {
      if (val.id != null) {
        this.DataAxios.TblCustomerId = val.id;
        this.$store.state.renderComponentCombo = false;
        this.$nextTick(() => {
          this.$store.state.renderComponentCombo = true;
        });
      }
    },
    GetResulContract(val) {
      if (val.id != null) {
        this.DataAxios.TblContractId = val.id;
        if (!this.propstblCustomerProducts) {
          this.value = [];
        }
        let DataAxios_GetData = {
          ArryfildValue: {},
          Method: "post",
          Action: "CustomerProduct/GetProductOfContract",
          Token: this.$session.get("Token"),
        };
        DataAxios_GetData.ArryfildValue.Id = val.id;
        this.$PostData(DataAxios_GetData)
          .then((data) => {
            // console.log(data);
            if (
              (!this.propstblCustomerProducts &&
                this.$route.params.Status == "Add") ||
              this.$route.params.Status == undefined
            ) {
              this.ListProducts = [];
            }
            this.options = data;
            this.GetSerialNum();
            this.CopyCustomerProducts = JSON.parse(JSON.stringify(data));
            this.GetFactors(val.id);
          })
          .finally(() => {
            this.$store.state.renderComponentGrid = false;
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true;
            });
          });
      }
    },
    ItemSelected(node) {
      this.value.push(node);
      var n = node;
      n["Count"] = n.Count;
      n["AmountKol"] = node.Amount * n.Count;
      n["SumTollTax"] = node.Toll + node.Tax;
      if (typeof node.Amount === "string") {
        node.Amount = Number(node.Amount.replace(/,/g, "").replace(/\./g, ""));
      }
      if (typeof node.Discount === "string") {
        node.Discount = Number(
          node.Discount.replace(/,/g, "").replace(/\./g, "")
        );
      }
      n["Miniaturize_AmountDiscount"] = node.AmountKol - node.Discount;
      n.Amount = this.$Comma3ragham(n.Amount);
      n.Discount = this.$Comma3ragham(n.Discount);
      n.TotallAmount = Math.floor(n.TotallAmount);
      this.ListProducts.push(n);
      this.CalcFactor();
    },
    ItemDeselect(node) {
      for (let index = 0; index < this.value.length; index++) {
        if (this.value[index].Id == node.Id) {
          this.value.splice(index, 1);
        }
      }
      for (let index = 0; index < this.ListProducts.length; index++) {
        if (this.ListProducts[index].Id == node.Id) {
          this.ClearError(node, node);
          this.ListProducts.splice(index, 1);
          this.ReloadProduct();
          this.CalcFactor();
        }
      }
    },
    CalcFactor() {
      this.TR_Result.S_Amount = 0;
      this.TR_Result.S_Discount = 0;
      this.TR_Result.S_Miniaturize_AmountDiscount = 0;
      this.TR_Result.S_SumTollTax = 0;
      this.TR_Result.S_SumTotallAmount = 0;

      this.ListProducts.forEach((el) => {
        if (el.tblComboGrpId12 == 1226) {
          //رسمی
          this.DataAxios.IsRasmi = true;
        }
        if (el.tblComboGrpId12 == 1227) {
          //غیر رسمی
          this.DataAxios.IsRasmi = false;
        }

        this.TR_Result.S_Amount += Number(el.AmountKol);

        if (typeof el.Discount === "string")
          this.TR_Result.S_Discount += Number(
            el.Discount.replace(/,/g, "").replace(/\./g, "")
          );
        else this.TR_Result.S_Discount += Number(el.Discount);

        var d =
          typeof el.Discount === "string"
            ? Number(el.Discount.replace(/,/g, "").replace(/\./g, ""))
            : Number(el.Discount);
        this.TR_Result.S_Miniaturize_AmountDiscount += Number(el.AmountKol) - d;

        this.TR_Result.S_SumTollTax += Number(el.AmountKol - d) * (this.IsTarixFactor ? this.ArzeshAfzode1402 : this.ArzeshAfzode1403);
        this.TR_Result.S_SumTotallAmount += Number(el.TotallAmount);

        if (
          this.propstblCustomerProducts &&
          this.$route.params.Status == "Edit"
        ) {
          this.CopyCustomerProducts.forEach((e) => {
            if (e.Id == el.Id) {
              e.TotallAmount < el.TotallAmount
                ? this.ErrorHandler(e, el)
                : this.ClearError(e, el);
            }
          });
        }
        if (
          (this.propstblCustomerProducts &&
            this.$route.params.Status == "Add") ||
          this.$route.params.Status == undefined
        ) {
          //محاسبه مبالغ فاکتور با مبالغ قرارداد و فاکتورهای قبلا صادر شده
          if (this.Factors.length > 0) {
            var x = this.Factors.filter(
              (x) => x.tblCustomerProductsId == el.Id
            );
            if (x.length > 0) {
              this.ErrorHandler(x[0], el, true);
            } else {
              this.CopyCustomerProducts.forEach((e) => {
                if (e.Id == el.Id) {
                  e.TotallAmount < el.TotallAmount
                    ? this.ErrorHandler(e, el)
                    : this.ClearError(e, el);
                }
              });
            }
          } else {
            this.CopyCustomerProducts.forEach((e) => {
              if (e.Id == el.Id) {
                e.TotallAmount < el.TotallAmount
                  ? this.ErrorHandler(e, el)
                  : this.ClearError(e, el);
              }
            });
          }
        }
      });
      this.ListProducts.length == 0 ? (this.ErrorList = []) : false;
      this.IsCalc = true;
    },
    CalcDiscount(e, row) {
      row.Miniaturize_AmountDiscount =
        row.AmountKol - e.target.value.replace(/,/g, "").replace(/\./g, "");
      row.SumTollTax =
        Number(
          row.AmountKol - e.target.value.replace(/,/g, "").replace(/\./g, "")
        ) *(this.IsTarixFactor ? this.ArzeshAfzode1402 : this.ArzeshAfzode1403);
      if (row.tblComboGrpId12 == 1227) {
        row.TotallAmount = row.Miniaturize_AmountDiscount;
      } else {
        row.TotallAmount = row.Miniaturize_AmountDiscount + row.SumTollTax;
      }
      this.CalcFactor();
    },
    CalcAmount(e, row) {
      var d =
        typeof row.Discount === "string"
          ? Number(row.Discount.replace(/,/g, "").replace(/\./g, ""))
          : Number(row.Discount);
      row.AmountKol =
        Number(e.target.value.replace(/,/g, "").replace(/\./g, "")) * row.Count;
      row.Miniaturize_AmountDiscount = Number(row.AmountKol) - d;
      row.SumTollTax = (Number(row.AmountKol) - d) *(this.IsTarixFactor ? this.ArzeshAfzode1402 : this.ArzeshAfzode1403);
      if (row.tblComboGrpId12 == 1227) {
        row.TotallAmount = row.Miniaturize_AmountDiscount;
      } else {
        row.TotallAmount = row.Miniaturize_AmountDiscount + row.SumTollTax;
      }
      this.CalcFactor();
    },
    CalcCount(e, row) {
      var d =
        typeof row.Discount === "string"
          ? Number(row.Discount.replace(/,/g, "").replace(/\./g, ""))
          : Number(row.Discount);
      row.AmountKol =
        Number(row.Amount.replace(/,/g, "").replace(/\./g, "")) *
        e.target.value;
      row.Miniaturize_AmountDiscount = Number(row.AmountKol) - d;
      row.SumTollTax = (Number(row.AmountKol) - d) *(this.IsTarixFactor ? this.ArzeshAfzode1402 : this.ArzeshAfzode1403);
      if (row.tblComboGrpId12 == 1227) {
        row.TotallAmount = row.Miniaturize_AmountDiscount;
      } else {
        row.TotallAmount = row.Miniaturize_AmountDiscount + row.SumTollTax;
      }
      this.CalcFactor();
    },
    ReloadProduct() {
      this.value = [];
      let DataAxios_GetData = {
        ArryfildValue: {},
        Method: "post",
        Action: "CustomerProduct/GetProductOfContract",
        Token: this.$session.get("Token"),
      };
      DataAxios_GetData.ArryfildValue.Id = this.DataAxios.TblContractId;
      this.$PostData(DataAxios_GetData)
        .then((data) => {
          this.CopyCustomerProducts = JSON.parse(JSON.stringify(data));
          this.options = data;
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false;
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true;
          });
        });
    },
    Mab2persian(mab) {
      return Num2persian(mab) + " ریال ";
    },
    GetFactors(tblContractsId) {
      let DataAxios_GetData = {
        ArryfildValue: {},
        Method: "post",
        Action: "CustomerProduct/GetFactorCusromerProduct",
        Token: this.$session.get("Token"),
      };
      DataAxios_GetData.ArryfildValue.Id = tblContractsId;
      this.$PostData(DataAxios_GetData)
        .then((data) => {
          this.Factors = data;
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false;
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true;
          });
        });
    },
    ErrorHandler(ccp, RF, IsFactors) {
      var Find = false;
      this.ErrorList.forEach((element) => {
        if (element.Id == RF.Id) {
          Find = true;
          return;
        }
      });
      if (!Find) {
        var Err = {
          Text:
            "محصول | خدمات [ " +
            RF.Name +
            " ]" +
            " با کد کالای " +
            ccp.Id +
            " بیشتر از مبلغ قرارداد وارد شده ، مبلغ باقی مانده از قرارداد " +
            this.$Comma3ragham(ccp.TotallAmount) +
            " می باشد . ",
          Id: RF.Id,
        };
        if (IsFactors == true) {
          Err.Text =
            "محصول | خدمات [ " +
            RF.Name +
            " ]" +
            " با کد کالای " +
            ccp.Id +
            " در تاریخ " +
            ccp.IssueDate +
            " با شماره فاکتور : " +
            ccp.SerialId +
            " قبلا فاکــتور گردیده . ";
        }
        this.ErrorList.push(Err);
      }
      Err = { Text: "", Id: 0 };
    },
    ClearError(Obj, F) {
      for (let index = 0; index < this.ErrorList.length; index++) {
        if (this.ErrorList[index].Id == F.Id) {
          this.ErrorList.splice(index, 1);
        }
      }
    },
    SetFactor() {
      if (this.$ValidForm("GFactor")) {
        this.ListProducts.forEach((el) => {
          el["NameProduct"] = el.Name;
          el["AmountDiscount"] = el.Miniaturize_AmountDiscount;
          el.Amount = Number(el.Amount.replace(/,/g, "").replace(/\./g, ""));
          el.tblCustomerProductsId = el.Id;
          el.tblContractsId = this.DataAxios.TblContractId;
        });
        this.DataAxios.tblShobeId = this.$session.get("UserInfo").tblShobeId;
        this.DataAxios.tblUserGrpIdInsert =
          this.$session.get("UserInfo").tblUserGrpId;
        this.DataAxios.tblFactorCustomerProducts = this.ListProducts;
        let DataAxios_SetData = {
          ArryfildValue: {},
          Method: "post",
          Action: "Factor/SetFactor",
          Token: this.$session.get("Token"),
        };
        DataAxios_SetData.ArryfildValue = this.DataAxios;
        this.$PostData(DataAxios_SetData)
          .then((data) => {
            if (data.status == "Ok") {
              this.$toasted.success("فاکـــتور جدید ثبت گردید", {
                duration: 2000,
              });
              this.Factors = [];
              this.ErrorList = [];
              this.CopyCustomerProducts = [];
              this.value = [];
              this.options = [];
              this.ListProducts = [];
              this.DataAxios = {
                TblCustomerId: 0,
                TblContractId: 0,
                Description: "",
                IssueDate: "",
                SerialId: "",
                IsRasmi: true,
              };
              this.DataAxios.IssueDate = this.$GetJalaliDate();
              this.GetSerialNum();
              this.$router.push({ name: 'FactorManager'})
            }
          })
          .finally(() => {
            this.$store.state.renderComponentGrid = false;
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true;
            });
          });
      }
    },
    GetSerialNum() {
      let DataAxios_GetSeialFactor = {
        ArryfildValue: {},
        Method: "post",
        Action: "Factor/GetSeialFactor",
        Token: this.$session.get("Token"),
      };
      this.$PostData(DataAxios_GetSeialFactor)
        .then((data) => {
          if (this.$route.params.Status == "Edit") {
            this.DataAxios.SerialId = this.propsFactor.SerialId;
          } else {
            this.DataAxios.SerialId = data.number;
          }
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false;
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true;
          });
        });
    },
    EditFactor() {
      if (this.$ValidForm("GFactor")) {
        this.ListProducts.forEach((el) => {
          el["AmountDiscount"] = el.Miniaturize_AmountDiscount;
          el.Amount = Number(el.Amount.replace(/,/g, "").replace(/\./g, ""));
          el.tblCustomerProductsId = el.Id;
          el.Id = el.tblFactorCustomerProductsId;
          el.tblContractsId = this.DataAxios.TblContractId;
          el.NameProduct = el.Name;
        });
        this.DataAxios.tblShobeId = this.propsFactor.tblShobeId;
        this.DataAxios.Id = this.propsFactor.Id;
        this.DataAxios.tblUserGrpIdLastEdit =
          this.$session.get("UserInfo").tblUserGrpId;
        this.DataAxios.tblFactorCustomerProducts = this.ListProducts;
        let DataAxios_SetData = {
          ArryfildValue: {},
          Method: "post",
          Action: "Factor/EditFactor",
          Token: this.$session.get("Token"),
        };
        DataAxios_SetData.ArryfildValue = this.DataAxios;

        this.$PostData(DataAxios_SetData)
          .then((data) => {
            if (data.status == "Ok") {
              this.$toasted.success("فاکـــتور با موفقیت ویرایش گردید", {
                duration: 2000,
              });
              this.Factors = [];
              this.ErrorList = [];
              this.CopyCustomerProducts = [];
              this.value = [];
              this.options = [];
              this.ListProducts = [];
              this.DataAxios = {
                TblCustomerId: 0,
                TblContractId: 0,
                Description: "",
                IssueDate: "",
                SerialId: "",
                IsRasmi: true,
              };
              this.DataAxios.IssueDate = this.$GetJalaliDate();
              this.GetSerialNum();
            }
          })
          .finally(() => {
            this.$store.state.renderComponentGrid = false;
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true;
            });
          });
      }
    },
    ReGetSerialNum() {
      let DataAxios_GetSeialFactor = {
        ArryfildValue: {},
        Method: "post",
        Action: "Factor/GetSeialFactor",
        Token: this.$session.get("Token"),
      };
      this.$PostData(DataAxios_GetSeialFactor)
        .then((data) => {
          this.DataAxios.SerialId = data.number;
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false;
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true;
          });
        });
    },
    GetResultPishNevis(data) {
      if (data.id != null) {
        this.DataAxios.Description = data.name;
      }
    },
  },
  mounted() {
     this.IsTarixFactor=this.propstblCustomerProducts[0].contractStartDate.substring(0, 4)<'1403' ? true : false
    if (this.propstblCustomerProducts && this.$route.params.Status == "Add") {
      this.DataAxios.TblCustomerId =
        this.propstblCustomerProducts[0].TblCustomerId;
      this.refGetResulContract = this.propstblCustomerProducts[0].TblContractId;
      this.DataAxios.IsRasmi = this.propstblCustomerProducts[0].IsRasmi;
      this.propstblCustomerProducts.forEach((element) => {
        element.Name = element.ProductName;
        element.TotallAmount = Math.floor(element.TotallAmount);
        var n = element;
        n["Count"] = n.Count;
        n["AmountKol"] = element.Amount * n.Count;
        n["SumTollTax"] = element.Toll + element.Tax;
        if (typeof element.Amount === "string") {
          element.Amount = Number(
            element.Amount.replace(/,/g, "").replace(/\./g, "")
          );
        }
        if (typeof element.Discount === "string") {
          element.Discount = Number(
            element.Discount.replace(/,/g, "").replace(/\./g, "")
          );
        }
        n["Miniaturize_AmountDiscount"] = element.AmountKol - element.Discount;
        n.Amount = this.$Comma3ragham(n.Amount);
        n.Discount = this.$Comma3ragham(n.Discount);
        this.ListProducts.push(n);
        this.CalcFactor();
        this.value.push(element.Id);
      });
    }
    if (this.propstblCustomerProducts) {
      this.Disable = true;
      this.comboKey++;
    }

    if (this.propstblCustomerProducts && this.$route.params.Status == "Edit") {
      this.DataAxios.IssueDate = this.propsFactor.IssueDate;
      this.DataAxios.SerialId = this.propsFactor.SerialId;
      this.DataAxios.Description = this.propsFactor.Description;
      this.DataAxios.TblCustomerId =
        this.propstblCustomerProducts[0].TblCustomerId;
      this.DataAxios.TblContractId =
        this.propstblCustomerProducts[0].TblContractId;
      this.refGetResulContract = this.propstblCustomerProducts[0].TblContractId;
      this.ReloadProduct();

      this.propstblCustomerProducts.forEach((element) => {
        element.Name = element.NameProduct;
        var n = element;
        n["Count"] = n.Count;
        n["AmountKol"] = element.AmountKol;
        n["SumTollTax"] = element.SumTollTax;
        n["tblComboGrpId12"] = this.propsFactor.tblComboGrpId12;
        if (typeof element.Amount === "string") {
          element.Amount = Number(
            element.Amount.replace(/,/g, "").replace(/\./g, "")
          );
        }
        if (typeof element.Discount === "string") {
          element.Discount = Number(
            element.Discount.replace(/,/g, "").replace(/\./g, "")
          );
        }
        n["Miniaturize_AmountDiscount"] = element.AmountDiscount;
        n.Amount = this.$Comma3ragham(n.Amount);
        n.Discount = this.$Comma3ragham(n.Discount);
        n.Id = n.tblCustomerProductsId;

        this.ListProducts.push(n);
        this.CalcFactor();
        this.value.push(element.Id);
      });
    }

    if (
      this.$route.params.Status == undefined ||
      (this.$route.params.Status != "Edit" &&
        this.$route.params.Status == "Add")
    ) {
      this.DataAxios.IssueDate = this.$GetJalaliDate();
      this.GetSerialNum();
    }
    if (this.DataAxios.TblCustomerId != 0) {
      this.comboKey++;
    }
  },
};
</script>
<style scoped>
.D_Products {
  background: var(--sidebar-action-bg);
  border-radius: 5px;
}
tr {
  color: var(--sidebar-color-item) !important;
}
table {
  background: var(--sidebar-bg-color) !important;
  color: var(--sidebar-color-item);
}
td {
  border-color: var(--table-border-color) !important;
}
th {
  font-weight: normal;
  text-align: center;
  font-size: 12px;
  color: var(--sidebar-color-item) !important;
  border-color: var(--table-border-color) !important;
}
thead {
  border-color: var(--table-border-color) !important;
}
tr:hover {
  color: var(--sidebar-color-item) !important;
  background: var(--sidebar-bg-color) !important;
}
#header-Selected {
  width: 5% !important;
}
.borderd span:not(.fas):not(.fad) {
  color: rgb(253, 93, 8) !important;
}
</style>
